export const formatTimestamp = (timestampString: string) => {
  const date = new Date(timestampString)

  const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  })

  const timeZoneName =
    new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
      .formatToParts(date)
      .find(part => part.type === 'timeZoneName')?.value || 'Local'

  return `${dateTimeFormatter.format(date)} (${timeZoneName})`
}

export const formatDate = (dateString: string) => {
  const date = new Date(dateString)

  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })

  const timeZoneName =
    new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
      .formatToParts(date)
      .find(part => part.type === 'timeZoneName')?.value || 'Local'

  return `${dateFormatter.format(date)} (${timeZoneName})`
}
